import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { OrigemSelectComponent } from './origem-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        OrigemSelectComponent
    ],
    exports: [
        OrigemSelectComponent
    ]
})
export class OrigemSelectModule { }
